export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID ?? 'ATKbH5n7CNywOzBHtLPEKnFBbo57Ag-5lZxQYZ6ZsSKUkiC6krjyqpfFJxv3SE0Ni2CPRLywMB0Zp7Kb'
export const STRAPI_URL = process.env.REACT_APP_STRAPI_URL ?? 'https://strapi-3tgn.onrender.com'
export const PHP_URL = process.env.REACT_APP_PHP_URL ?? 'https://rock-im-garten.com'
